import React from 'react';
import { Row, Col } from 'react-bootstrap';

import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';

const HeaderTitle = ({ globalFilter, setGlobalFilter }) => (
    <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
            <h6 className="mb-0">Preguntas EPsT</h6>
        </Col>
        <Col xs="auto">
            <AdvanceTableSearchBox
                className="input-search-width"
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                placeholder="Buscar"
            />
        </Col>
    </Row>
);

export default HeaderTitle;